import { ICard, CardFlag, CardType, ICardInformation } from '../types'

export class Card {
  public id: number
  public finalCardNumbers: string
  public flag: CardFlag
  public flagURL: string
  public isDefault: boolean
  public type: CardType

  constructor(card: ICard) {
    this.id = card.id
    this.finalCardNumbers = card.finalCardNumbers
    this.flag = card.flag
    this.flagURL = card.flagURL
    this.isDefault = card.isDefault
    this.type = card.type
  }
}

export class CardInformation {
  public cardNumber: string
  public holderName: string
  public expirationDate: string
  public cvv: string
  public isDefault: boolean

  constructor(cardInformation: ICardInformation) {
    this.cardNumber = cardInformation.cardNumber
    this.holderName = cardInformation.holderName
    this.expirationDate = cardInformation.expirationDate
    this.cvv = cardInformation.cvv
    this.isDefault = cardInformation.isDefault
  }
}
export class AddressInformation {
  public cep: string
  public streetName: string
  public number: string
  public complement: string
  public neighborhood: string
  public city: string
  public state: string
  public country: string

  constructor(addressInformation: AddressInformation) {
    this.cep = addressInformation.cep
    this.streetName = addressInformation.streetName
    this.number = addressInformation.number
    this.complement = addressInformation.complement
    this.neighborhood = addressInformation.neighborhood
    this.city = addressInformation.city
    this.state = addressInformation.state
    this.country = addressInformation.country
  }
}
